import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ConnectionHardwareConfiguration } from '@paragon/contract-library';

const initialState: readonly ConnectionHardwareConfiguration[] = [];

const hangerConfigurationsSlice = createSlice({
  name: 'hangerConfigurations',
  initialState,
  reducers: {
    setHangerConfigurations: (state, action: PayloadAction<readonly ConnectionHardwareConfiguration[]>) => {
      return action.payload;
    },
  },
});

export const { setHangerConfigurations } = hangerConfigurationsSlice.actions;
export const hangerConfigurations = hangerConfigurationsSlice.reducer;
